import LikeThisStyle from "@/features/landingPages/likeThisStyle";
import Navigation from "@/components/layout/Navigation";
import SimpleStackedPreview from "@/features/landingPages/SimpleStackedPreview";
import { mockNewsletterData } from "@/features/landingPages/mockNewsletterData";
import TrustSection from "@/features/landingPages/TrustSection";
import {
  GetStartedButton,
  GetStartedButtonInverted,
} from "@/features/landingPages/LandingButtons";
const AILandingSection = () => {
  return (
    <>
      <div className="relative flex flex-col items-center justify-center overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-blue-50 z-0"></div>

        {/* Dot pattern overlay */}
        <div className="absolute inset-0 z-10 pointer-events-none opacity-20 dot-pattern"></div>

        {/* Navigation Component */}
        <Navigation />

        {/* Main content section */}
        <main className="relative z-20 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-6xl xl:max-w-7xl mx-auto mt-16 sm:mt-24 md:mt-32 lg:mt-40 mb-16 sm:mb-24 md:mb-32 lg:mb-40 px-4 sm:px-6 md:px-8 lg:px-12">
          <section
            className="lg:flex lg:flex-row lg:items-center lg:justify-between lg:gap-16 xl:gap-20 space-y-6 sm:space-y-8 lg:space-y-0"
            aria-labelledby="hero-heading"
          >
            <div className="flex flex-col items-center lg:items-start text-center lg:text-left lg:w-[60%] max-w-xs sm:max-w-sm md:max-w-md lg:max-w-2xl xl:max-w-3xl mx-auto lg:mx-0">
              <h1
                id="hero-heading"
                className="text-4xl sm:text-5xl md:text-6xl lg:text-6xl xl:text-7xl font-bold text-gray-900 mb-4 sm:mb-6 md:mb-8 lg:mb-10 leading-tight"
              >
                Your very own personalized AI newsletter{" "}
              </h1>

              {/* Newsletter preview - visible on mobile and tablet, hidden on desktop */}
              <div className="block lg:hidden w-full max-w-sm sm:max-w-md md:max-w-lg mx-auto mb-6 sm:mb-8">
                <SimpleStackedPreview newsletters={mockNewsletterData} />
              </div>

              <p className="text-lg sm:text-xl text-gray-700 mb-6 sm:mb-8 md:mb-10 lg:mb-12 leading-relaxed">
                Set your topics, vibe, and schedule to generate your own
                newsletter about the latest in AI
              </p>

              <div className="block max-w-[500px] mt-2 sm:mt-0">
                <GetStartedButton />
              </div>
            </div>

            {/* Right column with image - visible on desktop only */}
            <div className="hidden lg:block w-full mx-auto mb-6 sm:mb-8">
              <SimpleStackedPreview newsletters={mockNewsletterData} />
            </div>
          </section>
        </main>
      </div>

      <section
        id="how-it-works"
        className="dot-pattern-blue bg-blue-600 mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-12 sm:py-16 md:py-20"
        aria-labelledby="quality-heading"
      >
        <div className="w-full flex flex-col md:flex-row gap-8 sm:gap-12 md:gap-16 items-center">
          <div className="md:w-1/2">
            <LikeThisStyle />
          </div>

          <div className="md:w-1/2 lg:w-1/3 px-4 sm:px-8 md:px-12 lg:px-6 max-w-3xl mx-auto">
            {/* After the heading, before the description */}
            <div className="text-center md:text-left mb-6 sm:mb-8">
              <blockquote className="text-base sm:text-lg text-blue-100 italic mb-2">
                "Every day we are bombarded with so much news about AI that it's
                increasingly difficult to know what is signal and what is
                noise."
              </blockquote>
              <cite className="text-sm text-blue-200">
                — Chamath Palihapitiya
              </cite>
            </div>
            <h2
              id="quality-heading"
              className="max-w-4xl mx-auto text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6 sm:mb-8 md:mb-12 
              leading-tight text-center md:text-left"
            >
              Control what lands in your inbox
            </h2>

            <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-white font-normal leading-relaxed mb-6 sm:mb-8">
              A newsletter that respects your time, taste, and inbox. Just pick
              the topics you care about, set the writing tone, and choose when
              your updates land.
            </div>
            <div className="mt-6 sm:mt-8 md:mt-8 max-w-[500px] mx-auto">
              <GetStartedButtonInverted />
            </div>
          </div>
        </div>
      </section>
      <TrustSection />

      {/* Personal Footer */}
      <footer
        className="w-full bg-gray-800 text-white py-12 sm:py-16"
        role="contentinfo"
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
          {/* Main Content - Centered */}
          <div className="text-center mb-8">
            {/* Trust & Personal Touch */}
            <div className="space-y-2 text-sm text-gray-400">
              <div>
                <a
                  href="https://www.linkedin.com/in/productmars/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-green-400 transition-colors duration-200"
                >
                  Made in public by Mars
                </a>{" "}
                🍦{" "}
                <a
                  href="https://www.buymeacoffee.com/marsescobin"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-green-400 hover:text-white transition-colors duration-200"
                >
                  Buy me a gelato
                </a>
              </div>
            </div>
          </div>

          <div className="text-center text-gray-400 text-sm">
            © 2025 AI News. All rights reserved.
          </div>
        </div>
      </footer>
    </>
  );
};

export default AILandingSection;
